import { render, staticRenderFns } from "./DedicationSalesByParsonTab.vue?vue&type=template&id=13be0ff1&"
import script from "./DedicationSalesByParsonTab.vue?vue&type=script&lang=js&"
export * from "./DedicationSalesByParsonTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports